export function getYoutubeVideoId(url) {
  const youtubeMatch = url.match(/(youtube|youtu)\.(com|be)\/((watch\?v=([-\w]+))|([-\w]+))/);

  if (youtubeMatch) {
    if (youtubeMatch[1] === 'youtube' && youtubeMatch[2] === 'com') {
      return youtubeMatch[5];
    }
    if (youtubeMatch[1] === 'youtu' && youtubeMatch[2] === 'be') {
      return youtubeMatch[3];
    }
  }
  return null;
}
